import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useStore } from "effector-react";
import { Preloader } from "../../../common/ui/Preloader/preloader";
import { ConfirmCode } from "../../../common/ui/ConfirmCode/ConfirmCode";
import { Counter } from "../../../common/ui/Counter/Counter";
import {
    empty,
    removeValidateMarksRU,
    validatePhoneRU,
} from "../../../common/functions";
import {
    $accounts,
    AddChargesToAccount,
    AddOwnerTypeToAccount,
    queryAccounts,
    storeAccountsSet,
    updateAccount,
} from "../../../common/accounts2";
import { pathAddAccountOnLogin, pathMain } from "../../../common/config/vars"
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../../login/style/Login.css";
import { getPhone, getSession, getUuid, setEmail } from "../../../common/localStorage";
import { $user, queryUserUpdatePhone } from "../../../common/user";
import { $SiteColors } from "../../../common/config/company-atts";
import { getCustomUserAgent, getCustomUserAgentASB, getCustomUserAgentKrk } from "../../../common/customUserAgent";
import { loggedIn, queryCheckSmsCode, querySendSmsCode } from "../../login/logics/reg";


toast.configure();

interface IPhoneBlock{
    setClose:React.Dispatch<React.SetStateAction<boolean>>
}

export const PhoneChangeBlock = (params:IPhoneBlock) => {
    const [openSendSmsForm, setOpenSendSmsForm] = React.useState(false);
    const [isValid, setIsValid] = React.useState(false);
    const [showLoader, setShowLoader] = React.useState(false);
    const [showLoaderCode, setShowLoaderCode] = React.useState(false);
    const [disableInputs, setDisabledInputs] = React.useState(false);
    const [phoneStatus, setPhoneStatus] = React.useState("");
    const [codeStatus, setCodeStatus] = React.useState("");
    const [phoneValue, setPhoneValue] = React.useState("");
    const [showConfirm, setShowConfirm] = React.useState(false);
    const [confirmValue, setConfirmValue] = React.useState("");
    const [buttonText, setButtonText] = React.useState(
        "Отправить код на телефон"
    );
    const [showCounter, setShowCounter] = React.useState(false);
    const [verificationId, setVerificationId] = React.useState("");
    const [loggDone, setLoggDone] = React.useState(loggedIn());
    const [captcha, setCaptcha] = React.useState<JSX.Element | null>(
        <div id="recaptcha-block"></div>
    );
    const [time, setTime] = React.useState(40);

    const form = React.useRef<HTMLFormElement>(null);
    const accounts = useStore($accounts);
    const history = useHistory();

    React.useEffect(() => {
        if (form.current) setIsValid(form.current.checkValidity());
        if (!phoneValue) setIsValid(false);
    }, [phoneValue]);

    React.useEffect(() => {
        if (!loggDone)
            storeAccountsSet({
                loaded: false,
                fail: false,
                failMsg: "",
                accounts: [],
            });
    }, [loggDone]);

    React.useEffect(() => {
        if (captcha === null) setCaptcha(<div id="recaptcha-block"></div>);
    }, [captcha]);

    React.useEffect(() => {
        if (time <= 0) {
            setShowCounter(false);
            setTime(40);
            setButtonText("Отправить код повторно");
            setDisabledInputs(false);
            setIsValid(true);
        }
    }, [time]);
    //------------------------------------Для повторного   
    const [sendSmsFail, setSendSmsFail] = React.useState("");
    const [smsUserId, setSmsUserId] = React.useState("249");
    const [confirmLoading, setConfirmLoading] = React.useState(false);
    const [checkSmsSuccess, setCheckSmsSuccess] = React.useState("");

    const [checkSmsFail, setCheckSmsFail] = React.useState("");

    useEffect(() => {
        if (openSendSmsForm) {
            setShowLoader(true)
            querySendSmsCode({ setFailMsg: setSendSmsFail, setLoading: setShowLoader, setUserSmsId: setSmsUserId, phone: removeValidateMarksRU(validatePhoneRU(phoneValue).phone) })
        }

    }, [openSendSmsForm])

    useEffect(() => {
        if (!confirmLoading) {
            if (checkSmsSuccess != "") {//@ts-ignore
                queryUserUpdatePhone({ object: { phone: removeValidateMarksRU(phoneValue), login: removeValidateMarksRU(phoneValue) }, user: $user.getState() })
                    .then(() => {
                        setShowLoader(false);
                        setDisabledInputs(false);
                        setIsValid(true);
                        params.setClose(false)
                    })
                    .catch(() => {
                        setShowLoader(false);
                        setDisabledInputs(false);
                        setIsValid(true);
                        return 
                    });

            } else if (checkSmsFail != "") {
                toast.error(checkSmsFail)
            }
        }
    }, [confirmLoading])

    function handleFormSubmitPhoneCall(event: React.FormEvent) {
        event.preventDefault();
        setConfirmLoading(true)
        queryCheckSmsCode({ setFailMsg: setCheckSmsFail, setLoading: setConfirmLoading, setSuccessMsg: setCheckSmsSuccess, phone: removeValidateMarksRU(validatePhoneRU(phoneValue).phone), userSmsId: smsUserId, code: confirmValue })
    }

    // React.useEffect(() => {
    //     if (!empty(getUuid()) && !empty(getSession()) && !empty(getPhone())
    //         /* localStorage.getItem("phone") &&
    //          localStorage.getItem("session") &&
    //          localStorage.getItem("uuid")*/
    //     ) {
    //         if (accounts.loaded) {
    //             if (accounts.accounts.length > 0) {
    //                 history.push(pathMain);
    //             } else {
    //                 history.push(pathAddAccountOnLogin);
    //             }
    //         } else {
    //             queryAccounts()
    //                 .then(async res => {
    //                     var bar = new Promise((resolve, reject) => {
    //                         res.accounts.forEach(async (elem, index) => {
    //                             await updateAccount({ account: elem, accounts: res.accounts });
    //                             await AddChargesToAccount({ account: elem, accounts: res.accounts })
    //                             if (getCustomUserAgent() === getCustomUserAgentKrk()) {
    //                                 await AddOwnerTypeToAccount({ account: elem, accounts: res.accounts })
    //                             }
    //                             if (index === res.accounts.length - 1) resolve("@");
    //                         })
    //                     })
    //                     bar.then(() => {
    //                     });
    //                 })
    //                 .then(() => {
    //                     if (accounts.accounts.length > 0) {
    //                         history.push(pathMain);
    //                     } else {
    //                         history.push(pathAddAccountOnLogin);
    //                     }
    //                 })
    //                 .catch((err) => toast.error(err.message));
    //         }
    //     }
    // }, [accounts, history]);

    function handleChange(event: React.ChangeEvent<HTMLInputElement>) {
        const target = event.target;
        const value = target.value;
        const digitValue = value.replace(/\D/g, "");
        setPhoneValue(validatePhoneRU(digitValue).phone);
    }

    function handleFormSubmitPhone(event: React.FormEvent) {
        event.preventDefault();
        setPhoneStatus("");
        setDisabledInputs(true);
        setIsValid(false);
        setShowLoader(true);
        if (buttonText == "Отправить код повторно") {
            setOpenSendSmsForm(true)
            return
        }

        // phoneAuthR(
        //     "recaptcha-block",
        //     removeValidateMarksRU(phoneValue),
        //     setVerificationId,
        //     setShowLoader,
        //     setShowCounter,
        //     setShowConfirm,
        //     setPhoneStatus,
        //     setDisabledInputs,
        //     setIsValid,
        //     setCaptcha,
        //     captcha
        // );
    }

    function handleFormSubmitCode(event: React.FormEvent) {
        event.preventDefault();
        setShowLoaderCode(true);
        setCodeStatus("");

        // codeAuthR(confirmValue, verificationId, setCodeStatus).then((res: { status: any; phone: any; }) => {
        //     if (res.status && res.phone) {//@ts-ignore
        //         queryUserUpdatePhone({ object: { phone:res.phone, login: res.phone }, user: $user.getState() })
        //         .then(() => {
        //             setShowLoader(false);
        //             setDisabledInputs(false);
        //             setIsValid(true);
                    
        //             params.setClose(false)
        //         })
        //         .catch(() => {
        //             setShowLoader(false);
        //             setDisabledInputs(false);
        //             setIsValid(true);
        //             return 
        //         });
        //     } else setShowLoaderCode(false);
        // });
    }




    return (
        <div className="login" 
        style={{ backgroundColor: $SiteColors.getState().cardBackgroundColor+"44", position:"fixed", top:0, left:0, height:"100%", width:"100%" }}
        onClick={()=>params.setClose(false)}>
            <div className="login__container" style={{ backgroundColor: $SiteColors.getState().cardColor }} onClick={e=>e.stopPropagation()}>
                <h3 className="login__title">Смена номера телефона</h3>
                {/* {openSendSmsForm ?<LoginByPaySms phone={phoneValue}/> : */}
                <>
                    <form
                        className="login__form"
                        ref={form}
                        onSubmit={handleFormSubmitPhone}
                    >
                        <input
                            type="tel"
                            className="login__input"
                            placeholder="Введите номер телефона"
                            name="phone"
                            required
                            onChange={handleChange}
                            disabled={disableInputs}
                            value={phoneValue}
                            id="phone"
                            pattern="\+7\(\d{3}\)\d{3}-\d{2}-\d{2}"
                            maxLength={16}
                            autoComplete="off"
                        ></input>
                        <label htmlFor="phone" className="login__label">
                            Например, +7(962)544-74-12
                        </label>
                        {phoneStatus === "phoneSuccess" && (
                            <p className="login__status" style={{ color: $SiteColors.getState().backBtnTotalByMonthText }}>Код отправлен на Ваш телефон</p>
                        )}
                        {phoneStatus === "phoneError" && (
                            <p className="login__status login__status_error">
                                Что-то пошло не так. Попробуйте еще раз
                            </p>
                        )}
                        <div id="recaptcha-container">{captcha}</div>
                        <button type="submit" className="login__button" disabled={!isValid} style={{ backgroundColor: $SiteColors.getState().backBtnSubmit }}>
                            {showLoader && <Preloader small />}
                            {showCounter && <Counter time={time} setTime={setTime} />}
                            {!showLoader && !showCounter && buttonText}
                        </button>
                    </form>
                    <form
                        className={
                            showConfirm
                                ? "form__confirm-container form__confirm-container_open"
                                : "form__confirm-container"
                        }
                        onSubmit={openSendSmsForm ? handleFormSubmitPhoneCall : handleFormSubmitCode}
                    >
                        <p className="login__confirm-text">
                            {!openSendSmsForm ? "Введите код подтверждения, отправленный Вам на телефон" : "Введите последние 4 цифры входящего звонка"}
                        </p>
                        <ConfirmCode setConfirmValue={setConfirmValue} length={openSendSmsForm ? 4 : 6} />
                        {codeStatus === "codeError" && (
                            <p className="login__status login__status_error">
                                Что-то пошло не так. Попробуйте позже
                            </p>
                        )}
                        {codeStatus === "codeWrong" && (
                            <p className="login__status login__status_error">
                                Неверный код авторизации
                            </p>
                        )}
                        {sendSmsFail !== "" && (
                            <p className="login__status login__status_error">
                                {sendSmsFail}
                            </p>
                        )}
                        <button
                            type="submit"
                            className="login__button"
                            style={{ backgroundColor: $SiteColors.getState().backBtnSubmit }}
                            disabled={
                                !openSendSmsForm ?
                                    !showLoaderCode && confirmValue.length === 6 ? false : true :
                                    !showLoaderCode && confirmValue.length === 4 ? false : true
                            }
                        >
                            {showLoaderCode && <Preloader small />}
                            {!showLoaderCode && "Сменить номер"}
                        </button>
                    </form>
                </>
            </div>
        </div>
    );
};
